import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import FontAwesome from 'react-fontawesome';

export default class GenericCheckboxesDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
  }

  show = () => {
    this.setState({ isVisible: true });
    document.addEventListener('click', this.hide);
  };

  hide = e => {
    if (
      e.target.classList &&
      e.target.classList.contains('GCDHideControl') === false
    ) {
      this.setState({ isVisible: false });
      document.removeEventListener('click', this.hide);
    }
  };

  renderDropDown = () =>
    this.props.dropdownOptions
      .filter(({ visible }) => visible)
      .map(({ key, name, checked, title }) => (
        <div key={key}>
          <input
            id={`GenericCheckboxesDropdown-${key}`}
            type="checkbox"
            className="GCDHideControl"
            onChange={() => this.props.handleCheckboxChange(key)}
            checked={checked}
          />
          <label
            htmlFor={`GenericCheckboxesDropdown-${key}`}
            className="large GCDHideControl"
            title={title}
          >
            {name}
          </label>
        </div>
      ));

  render() {
    return (
      <div>{this.renderDropDown()}</div>
      // <div className={'fa-more-dropdown'}>
      //   <button
      //     onClick={this.show}
      //   >
      //     <span>{this.props.dropdownTitle}</span>
      //     <FontAwesome
      //       className={`fa fa-sort-desc ${!this.props.btnDisabled ? '' : 'fa-inverse'}`}
      //       name="dropdown"
      //       size="2x"
      //       style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
      //       aria-hidden="true"
      //     />
      //   </button>
      //   <div
      //     className={this.state.isVisible
      //          ? 'fa-dropdown-pane-custom'
      //          : 'fa-dropdown-pane fa-showComponent'}
      //     data-dropdown
      //   >
      //     <div className="button-list">
      //       {this.renderDropDown()}
      //     </div>
      //   </div>
      // </div>
    );
  }
}

GenericCheckboxesDropdown.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleCheckboxChange: PropTypes.func,
  // btnDisabled: PropTypes.bool,
  // dropdownTitle: PropTypes.string,
};
